import "../assets/less/progressbar.less";
import React, { useRef, useEffect, useCallback, useState, useMemo } from "react";
import ShowHide from "./ShowHide";
import BubbleMarker from "./BubbleMarker";
import HeartAnimation from "./HeartAnimation";

export const ProgressBar = (props) => {
  const barRef = useRef(null);
  const [winWidth, setWinWidth] = useState(window.innerWidth);
  const { data, animationProps, handleOnRender } = props;
  const { showHeart } = animationProps;
  const { goalRef, goalTarget, currentGoalState, currentGoalStateLabel="", goalTargetLabel="", displayType="simple" } = data || {};
  const designType = displayType ? displayType : "simple";

  const getPercent = useCallback(() => {  
    const percent = (+currentGoalState / +goalTarget) * 100;
    return percent >= 100 ? 100 : percent;
  }, [goalTarget, currentGoalState]);

  const getDimensions = (elem) => {
    const styles = window.getComputedStyle(elem);
    const dims = {
      width: elem.clientWidth - parseFloat(styles.paddingLeft) - parseFloat(styles.paddingRight)
    };

    return dims;
  };

  useEffect(() => {
    const resizeListener = () => {
      if(winWidth !== window.innerWidth) {
        setWinWidth(window.innerWidth);
      }
    };

    window.addEventListener("resize", resizeListener);

    return () => {
      window.removeEventListener("resize", resizeListener);
    };
  }, [barRef]);

  useEffect(() => {
    setTimeout(() => {
      handleOnRender();
    }, 100);
  }, []);

  useEffect(() => {
    const percent = getPercent();
    barRef.current.style.setProperty("--goal-percent", `${percent}%`);
  }, [goalTarget, currentGoalState, data]);

  useEffect(() => {
    /* This is for the tracking icon for the bubble icon */
    if (barRef.current) {
      const percent = getPercent();
      const dimensions = getDimensions(barRef.current);
      const barWidth = dimensions.width;
      const incrementPixelUnit = (parseFloat(barWidth) / 100);
      /**********************************************************************************************
        This is sensitive to the design of the bubble icon and the progress bar. (adjust when needed)
        This is not scientific - 32 plus (4/100 times the percent value). 
        0 percent is 32 offset 
        99 percent is roughly 36 offset. 
        100 percent is 34 offset because of the 2 pixel border. 
      ***********************************************************************************************/
      const offset = percent === 100 ? 34 : ((4 / 100) * percent) + 32;
      const incrementPixels = (incrementPixelUnit * percent) - offset;
      barRef.current.style.setProperty("--goal-increment-pixels", `${incrementPixels}px`);
    }
  }, [barRef, winWidth, goalTarget, currentGoalState, data]);

  return (
    <div className={`ProgressBar ${designType === 'bubble' ? 'ProgressBar--bubble' : ''}`} ref={barRef}>
      <ShowHide visible={designType === 'bubble'}>
        <BubbleMarker data={data} />
      </ShowHide>
      <ShowHide visible={showHeart && (designType === 'simple')}>
        <HeartAnimation goalRef={goalRef} {...animationProps}  />
      </ShowHide>
      <div className="Bar"></div>
      <footer className="GoalFooter">
        <div className="GoalCount"><strong>{currentGoalStateLabel}</strong> {goalTargetLabel}</div>
      </footer>
    </div>
  );
};

export default ProgressBar;